import { ESecondCategories } from '@/domains/investor/const/SecondCategories.enum'
import { EMainCategories } from '@/domains/investor/const/MainCategories.enum'
export { ITEMS_PER_PAGE } from '@/domains/investor/components/DataView/DataView.const'

export const GENERAL_MEETING_CATEGORIES = [
  ESecondCategories.EXTRAORDINARY_ASSEMBLY,
  ESecondCategories.ORDINARY_ASSEMBLY,
]

export const GENERAL_MEETING_CATEGORIES_SCOPE = {
  mainCategories: EMainCategories.PRESENTATION,
  allowedSecondCategories: GENERAL_MEETING_CATEGORIES,
}
